import {
  IDoctor,
  IInvoiceTemplate,
  INummernkreis,
  IPaymentServiceProvider,
  IPrivateEpisodenArt,
  IRegistrationDetails,
  IUserGroupDetails,
} from '@redmedical/datamodels/shared-datamodels';

import { Abrechnungsverfahren } from '../enums/abrechnungsverfahren.enum';
import { Privatabrechnungsverfahren } from '../enums/privatabrechnung-verfahren.enum';

export class AbrechnungsverfahrenTypes {
  static readonly Rechnungsdruck: IAbrechnungsverfahren = {
    key: Abrechnungsverfahren.Rechnungsdruck,
    name: Privatabrechnungsverfahren.RECHNUNGSDRUCK,
  };

  static readonly Verrechnungsstelle: IAbrechnungsverfahren = {
    key: Abrechnungsverfahren.Verrechnungsstelle,
    name: Privatabrechnungsverfahren.VERRECHNUNGSTELLE,
  };

  static readonly AllTypes: ReadonlyArray<IAbrechnungsverfahren> = [
    AbrechnungsverfahrenTypes.Rechnungsdruck,
    AbrechnungsverfahrenTypes.Verrechnungsstelle,
  ];

  static getByKey(key: string): IAbrechnungsverfahren | undefined {
    return AbrechnungsverfahrenTypes.AllTypes.find(a => a.key === key);
  }
}

export interface IAbrechnungsverfahren<NAME extends Privatabrechnungsverfahren = Privatabrechnungsverfahren> {
  key: Lowercase<NAME>;
  name: NAME;
}

export interface IPrivateBillingUnitWithRelations {
  doctors: Array<IDoctor>;
  privateEpisodenArten: Array<IPrivateEpisodenArt>;
  userGroupDetails: Array<IUserGroupDetails>;
  bsnr?: string;
  erlaubteAbrechnungsverfahren: Array<IAbrechnungsverfahren>;
  bevorzugtesAbrechnungsverfahren: IAbrechnungsverfahren;
  padMitgliedsnummer?: string;
  verrechnungsstelle?: IPaymentServiceProvider;
  nummernkreis: INummernkreis;
  praxisNameRechnungsdruck: string;
  rechnungsvorlage: IInvoiceTemplate;
}

export interface IPrivateBillingUnitFormDataInit {
  privateEpisodenArten: IPrivateEpisodenArt[];
  doctors: IDoctor[];
  paymentServiceProviders: IPaymentServiceProvider[];
  nummernkreise: INummernkreis[];
  isBsnrKnown: boolean;
  surgeryName: IRegistrationDetails['surgeryName'];
}
